import { env } from 'config/env';
import siteConfig from 'config/site.config';
import { store } from 'reduxStore/store';

/**
 * @description This function is used to generate the socket URL by the socket namespace.
 *
 * @param namespace a list of roles that were permitted to view the component
 * @return {String} The socket URL
 */
const socketURLGenerator = () => {
	const state = store.getState();
	const environment = state?.App?.environment || 'production';

	if (process.env.NODE_ENV === 'development') {
		return `http://localhost:${env.localApiPort}/zPlatform`;
	} else {
		const domain = siteConfig.getApplicationServerBaseDomain(environment);
		return `https://${domain}/zPlatform`;
	}
};

export default socketURLGenerator;
